import { searchParam } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod/v4';

import { ProjectDashboardPage } from '@/areas/projects/ProjectDashboard/pages/ProjectDashboardPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/dashboard')({
    staticData: { access: { permissions: ['view:rfq'] }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: z.object({ showOemDashboard: searchParam.boolean('optional') }),
    component: RouteComponent,
    // Otherwise a Notes draft follows the user to another project.
    remountDeps: ({ params }) => params.projectId,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const showOemDashboard = Route.useSearch({ select: (search) => search.showOemDashboard });
    return <ProjectDashboardPage {...pathParams} showOemDashboard={showOemDashboard} />;
}
